import { render, staticRenderFns } from "./SignInNameStep.vue?vue&type=template&id=0bca8498&lang=pug&"
import script from "./SignInNameStep.vue?vue&type=script&lang=ts&"
export * from "./SignInNameStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports